import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import SimpleReactValidator from 'simple-react-validator';
import { createTicketNationalityType, getTicketNationalityTypeListDetails, editTicketNationalityType } from "../../redux/actions/master"

class TicketNationalityTypeModalClass extends Component {

	state = {
		ticketNationalityTypeDetails: {
            title: '',

		},
		isEdit: false,
	}

	componentWillMount() {
		this.validator = new SimpleReactValidator({
			element: message => <span className="error-message ">{message}</span>,
			autoForceUpdate: this,
			messages: {}
		});
	}

	componentWillReceiveProps(props) {

		let { modalDetails, isEdit } = props
		this.setState({
			ticketNationalityTypeDetails: modalDetails,
			isEdit: isEdit,
		})
	}

	handleInputs = ({ target: { value, name } }) => {

		let ticketNationalityTypeDetails = Object.assign({}, this.state.ticketNationalityTypeDetails)

		ticketNationalityTypeDetails[name] = value

		this.setState({
			ticketNationalityTypeDetails
		})


	}

	handleSubmit = () => {

		if (this.validator.allValid()) {

			let { ticketNationalityTypeDetails: { title, id = '' }, isEdit } = this.state

			let body = {
                title: title,
                status:1
			}

			if (!isEdit) {

				this.props.createTicketNationalityType(body).then(() => {

					this.props.getTicketNationalityTypeListDetails().then(() => {
						let temp = {
                            title: '',
						}

						this.setState({
							isEdit: false,
							ticketNationalityTypeDetails: temp

						})
					})
				})
			} else {
				console.log(id);
				this.props.editTicketNationalityType(id, body).then((message) => {

					this.props.getTicketNationalityTypeListDetails().then(() => {
						let temp = {
                            title: '',
						}

						this.setState({
							isEdit: false,
							ticketNationalityTypeDetails: temp

						})
					})

				})
			}
			this.props.toggle()

			this.validator.hideMessages();

		} else {
			this.setState({
				isError: true
			})
			this.validator.showMessages();

		}
	}
	render() {

		let { isError, isEdit, toggle } = this.props

		let { ticketNationalityTypeDetails} = this.state

		this.validator.purgeFields();
		let { title } = ticketNationalityTypeDetails

		return (
			<section className="side-slider h-100">
				<div className="slider-header p-4">
					<div className="d-flex align-items-center">
						<h5 className="sair-sec-title"> {isEdit ? "Edit Ticket Nationality Type" : "Add Ticket Nationality Type"}</h5>
						<div className="ml-auto">
							<i className="icon-close font-md px-2 cursor-pointer"
								onClick={toggle}
							></i>
						</div>
					</div>
				</div>
				<div className="slider-body p-4">
					<div className={`row no-gutters ${isError ? "was-validated" : ""}`}>
						<div className="col-md-12 form-group">
							<label>Ticket Nationality Type</label>
							<input
								className={`form-control ${this.validator.message('title', title, 'required') ? 'inValid' : ''}`} id="title"
								placeholder=""
								name="title"
								value={title}
								type="text"
								onChange={this.handleInputs}


							/>
							{this.validator.message('title', title, 'required')}
						</div>

					</div>

					<hr />
					<button
						className="btn btn-primary"

						onClick={() => this.handleSubmit()}

					>{isEdit ? "Update" : "Submit"}</button>
				</div>
			</section>
		)
	}
}

const mapStateToProps = state => {

	return {}

};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		createTicketNationalityType,
		getTicketNationalityTypeListDetails,
		editTicketNationalityType
	}, dispatch)
};



export const TicketNationalityTypeModal = connect(mapStateToProps, mapDispatchToProps)(TicketNationalityTypeModalClass)
